const SetTimeRunMedia = (questionCode, type, firstKeyLcStr) => {
    let typeMedia = document.getElementsByTagName(type)[0];
    if (typeMedia && questionCode) {
        try {
            let timeMediaRan = `${firstKeyLcStr}${questionCode}`;
            let timeDurationMediaRan = `${firstKeyLcStr}Duration${questionCode}`;
            let currentTime = Number(localStorage.getItem(timeMediaRan));

            typeMedia.currentTime = currentTime ? currentTime : 0;

            typeMedia.ontimeupdate = function () {
                if (typeMedia.currentTime > 0) {
                    localStorage.setItem(timeMediaRan, typeMedia.currentTime);
                    localStorage.setItem(timeDurationMediaRan, typeMedia.duration);
                }
            };
        }catch (e) {
            //log bug
        }
    }
};

export default SetTimeRunMedia;
